import React from 'react';
import { translate } from '../utils/wp.js';

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    componentDidCatch = () => {
        this.setState({hasError: true});
    };

    onClickReload = () => {
        document.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className={'p-6 mb-2 bg-red rounded text-center md:p-6'}>
                    <div className={'block w-full text-center text-sm font-bold'}>
                        {translate('global_error_message')}
                    </div>
                    <button
                        className="gap-x-2 rounded-full px-6 py-3 mt-4 my-auto text-xs font-bold bg-white text-red"
                        onClick={this.onClickReload}
                    >
                        {translate('global_error_message_action')}
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}
